export const fetchShippingAdvisoryData = async () => {
  try {
    const response = await fetch('./content/ship/page-components/article/advisories.json', {
        cache: "no-cache"
    });
    const shippingAdvisoryData = await response.json();
    return shippingAdvisoryData;
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchShippingAdvisoryData.js